import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { getAvailability } from "../common/api";
import Availability from "../Availability";
import notifier from "../common/Notifier";
import Notifier from "../common/Notifier";
import { Call } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

export const Home = () => {
  const [availability, setAvailability] = useState(null);
  const isMobile = useMediaQuery("(max-width:600px)");
  const theme = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    fetchAvailability();
    const destroy = notifier.subscribe("refresh", () => {
      fetchAvailability();
    });
    return () => {
      destroy();
    };
  }, []);

  const fetchAvailability = async () => {
    Notifier.notify("loading", true);
    const data = await getAvailability();
    Notifier.notify("loading", false);
    setAvailability(data);
  };

  const handleCall = () => {
    window.location.href = "tel:+91 94892 09189";
  };

  return (
    <Box sx={{ minHeight: "100vh", position: "relative" }}>
      {/* Logo */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          py: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <img
          src="/images/logo.png"
          alt="logo"
          style={{ width: isMobile ? "120px" : "160px" }}
        />
      </Box>

      {/* Availability Section */}
      <Availability availability={availability} />

      {/* Sticky Footer - Call Button */}
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          p: 2,
          backgroundColor: theme.palette.background.paper,
          boxShadow: "0 -4px 20px rgba(0,0,0,0.1)",
          zIndex: 1000,
        }}
      >
        <Button
          variant="contained"
          fullWidth
          size="large"
          startIcon={<Call />}
          onClick={handleCall}
          sx={{
            py: 1.5,
            borderRadius: "12px",
            fontSize: "1rem",
            fontWeight: 600,
            textTransform: "none",
            boxShadow: "0 4px 12px rgba(152, 48, 47, 0.3)",
            "&:hover": {
              boxShadow: "0 6px 16px rgba(152, 48, 47, 0.4)",
            },
          }}
        >
          {t("call-to-book")}
        </Button>
      </Box>
    </Box>
  );
};
